export default __webpack_public_path__ + "static/media/francheville26.e65a7528.jpg";